import { ScreenHeader } from '@/components/layout/screen-header';
import { PageTitle } from '@/components/seo/page-title';
import { Linking, Pressable, ScrollView, Text, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import Svg, { Path } from 'react-native-svg';

const DISCORD_URL = 'https://discord.gg/kmvXZsDx4y';

export function AlphaProgramScreen() {
  return (
    <SafeAreaView className="flex-1" edges={['top']}>
      <PageTitle title="Alpha Program" />
      <ScreenHeader title="Alpha Program" showBackButton />
      <ScrollView
        className="flex-1"
        contentContainerStyle={{ paddingHorizontal: 16, paddingBottom: 40 }}
      >
        <View style={{ gap: 16, paddingTop: 8 }}>
          <Text className="text-lg font-bold text-foreground">
            Welcome to the Flavrly Alpha
          </Text>
          <Text className="text-base text-foreground">
            You&apos;re one of the first people to use Flavrly, and that&apos;s not just a
            nice thing to say. It actually matters. The app you&apos;re looking at
            right now is a foundation. It works, but it&apos;s early. Features are
            still being built, things might occasionally break, and some screens
            may feel a little empty. That&apos;s where you come in.
          </Text>

          <Text className="text-lg font-bold text-foreground">
            What&apos;s working now
          </Text>
          <Text className="text-base text-foreground">
            You can find restaurants, leave dish-level reviews, check in, manage
            your profile, add friends, and browse your activity feed. These are
            the building blocks of everything else. The more you use them
            (especially leaving reviews), the more useful the app becomes for
            everyone.
          </Text>

          <Text className="text-lg font-bold text-foreground">
            What&apos;s coming
          </Text>
          <Text className="text-base text-foreground">
            We&apos;re actively building out badges, challenges, personalized
            recommendations, push notifications, and more. These features depend
            on having real data from real users, which is exactly why this stage
            matters so much. Every review you leave and every check-in you make
            is helping shape what comes next.
          </Text>

          <Text className="text-lg font-bold text-foreground">
            A note about bugs and rough edges
          </Text>
          <Text className="text-base text-foreground">
            If something looks off, feels slow, or doesn&apos;t work the way you&apos;d
            expect, that&apos;s not unusual for this stage. We&apos;re fixing things
            continuously. If you want to let us know about something, the best
            place to do that is in our Discord community.
          </Text>

          <Text className="text-lg font-bold text-foreground">
            Join the conversation
          </Text>
          <Text className="text-base text-foreground">
            We set up a Discord server for this group to talk directly with us
            and each other. It&apos;s the fastest way to report a bug, suggest a
            feature, or just tell us what you think. We&apos;re in there and we&apos;re
            listening.
          </Text>

          <Pressable
            onPress={() => Linking.openURL(DISCORD_URL)}
            style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}
          >
            <Svg width={18} height={18} viewBox="0 0 24 24">
              <Path
                fill="#5865F2"
                d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z"
              />
            </Svg>
            <Text style={{ color: '#5865F2', fontSize: 16, fontWeight: '600' }}>
              Join the Flavrly Discord
            </Text>
          </Pressable>

          <Text className="text-lg font-bold text-foreground">Thank you</Text>
          <Text className="text-base text-foreground">
            Seriously. Flavrly doesn&apos;t become what we want it to be without
            people actually using it in these early days. Your reviews, your
            feedback, and your patience are all making a real difference.
          </Text>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}
